export default "/react/logoStukach-b95d9b5c.png";